var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M37.8213 0C50.5238 0 60.8213 10.2975 60.8213 23V37C60.8213 49.7025 50.5238 60 37.8213 60H23.8213C11.1187 60 0.821289 49.7025 0.821289 37V23C0.821289 10.2975 11.1187 0 23.8213 0H37.8213Z",
    fill: "#4AD991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9324 40.8889H43.2657C44.1248 40.8889 44.8213 41.5853 44.8213 42.4444C44.8213 43.3036 44.1248 44 43.2657 44H18.3768C17.5177 44 16.8213 43.3036 16.8213 42.4444V17.5556C16.8213 16.6964 17.5177 16 18.3768 16C19.236 16 19.9324 16.6964 19.9324 17.5556V40.8889Z",
    fill: "#4AD991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.7339 34.175C25.1463 34.8017 24.1619 34.8335 23.5351 34.2459C22.9084 33.6583 22.8766 32.6739 23.4642 32.0472L29.2975 25.8249C29.8658 25.2188 30.8101 25.1662 31.4421 25.7056L36.0461 29.6343L42.0448 22.0361C42.5771 21.3618 43.5553 21.2467 44.2296 21.779C44.9039 22.3114 45.019 23.2895 44.4866 23.9638L37.4866 32.8305C36.9399 33.5231 35.9271 33.6227 35.2559 33.0499L30.5519 29.0358L25.7339 34.175Z",
    fill: "#4AD991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.6a87755fe41c05977774190eaa900980.svg";
export { ForwardRef as ReactComponent };